import { render, staticRenderFns } from "./user-wizard-done.vue?vue&type=template&id=6cca89e6&scoped=true"
import script from "./user-wizard-done.vue?vue&type=script&lang=js"
export * from "./user-wizard-done.vue?vue&type=script&lang=js"
import style0 from "./user-wizard-done.vue?vue&type=style&index=0&id=6cca89e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cca89e6",
  null
  
)

export default component.exports